// The centred header every public page shares (PROTO build.py `nav()`):
// brandmark, the five doors on one line, a phone menu button. No props —
// the current door is derived from the route.
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const DOORS: ReadonlyArray<{ href: string; label: string }> = [
  { href: '/about', label: 'About Clan Heart' },
  { href: '/join', label: 'Join our ranks' },
  { href: '/lore', label: 'Epic Clan Lore' },
  { href: '/news', label: 'Public News Paper' },
  { href: '/cave', label: 'Hidden Treasure Cave' },
];

/** /code and /leaving belong to the Join door; any /cave/... sub-route
 * belongs to the Cave door — mirrors build.py's PARENT map and the
 * startsWith check PublicLayout uses for the dark theme. */
function currentDoor(pathname: string): string {
  if (pathname === '/code' || pathname === '/leaving') return '/join';
  if (pathname === '/cave' || pathname.startsWith('/cave/')) return '/cave';
  return pathname;
}

export function SiteHeader() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const current = currentDoor(pathname);

  return (
    <header className={open ? 'nav open' : 'nav'}>
      <Link className="brand" to="/" aria-label="Clan Heart, home">
        <img src="/art/logo-ink.webp" alt="" />
      </Link>
      <nav className="links" id="menu" aria-label="Main">
        {DOORS.map((door) => (
          <Link key={door.href} to={door.href} aria-current={door.href === current ? 'page' : undefined}>
            {door.label}
          </Link>
        ))}
      </nav>
      <button
        className="menu-btn"
        type="button"
        aria-expanded={open}
        aria-controls="menu"
        onClick={() => setOpen((v) => !v)}
      >
        {open ? 'Close' : 'Menu'}
      </button>
    </header>
  );
}
